import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ContentCard from 'components/layout/ContentCard';
import {
  UnderwriteWarningBanner
} from 'components/underwrite/shared';
import { sendClientLog } from 'services/logService';

const PropertyUWDiscrepantData = ({ classes, selectedOpportunity, selectedOpportunityAmherstIndicative, header }) => {
  const [isAcknowledged, setIsAcknowledged] = useState(false); // Allow component to hide itself after user clicks Acknowledge

  if (!selectedOpportunity || !selectedOpportunityAmherstIndicative || isAcknowledged) return null;

  const amherstIndicativeBaths = selectedOpportunityAmherstIndicative.baths;
  const amherstIndicativeBeds = selectedOpportunityAmherstIndicative.beds;
  const amherstIndicativeSqft = selectedOpportunityAmherstIndicative.sqft;

  const discrepantData = {};
  // only do comparison when both selectedOpportunity indicative and amherst indicative both have value
  if (selectedOpportunity.baths != null && amherstIndicativeBaths != null && selectedOpportunity.baths !== amherstIndicativeBaths) {
    discrepantData.bathsIsDifferent = true;
  }
  // only do comparison when both selectedOpportunity indicative and amherst indicative both have value
  if (selectedOpportunity.beds != null && amherstIndicativeBeds != null && selectedOpportunity.beds !== amherstIndicativeBeds) {
    discrepantData.bedsIsDifferent = true;
  }
  // only do comparison when both selectedOpportunity indicative and amherst indicative both have value
  if (selectedOpportunity.sqft != null && amherstIndicativeSqft != null && selectedOpportunity.sqft !== amherstIndicativeSqft) {
    discrepantData.sqftIsDifferent = true;
  }
  // If there is no difference at all, do not render this component
  if (!discrepantData.bathsIsDifferent && !discrepantData.bedsIsDifferent && !discrepantData.sqftIsDifferent) return null;
  let headerProps = {};
  if (header) {
    headerProps = {
      style: { textAlign: 'center' },
      height: 62,
      width: 370
    }
  }
  return (
    <UnderwriteWarningBanner
      message='There are discrepancies between Transaction Opportunity and Amherst data.'
      contentButtonText='View'
      {...headerProps}
    >
      <ContentCard contentHeight='300px' cardWidth='450px' title='Discrepant Data' style={{ margin: 0 }}>
        <>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Transaction Opportunity</TableCell>
                <TableCell>Amherst</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {discrepantData.bedsIsDifferent &&
                <TableRow>
                  <TableCell>Beds</TableCell>
                  <TableCell>{selectedOpportunity.beds}</TableCell>
                  <TableCell>{amherstIndicativeBeds}</TableCell>
                </TableRow>
              }
              {discrepantData.bathsIsDifferent &&
                <TableRow>
                  <TableCell>Baths</TableCell>
                  <TableCell>{selectedOpportunity.baths}</TableCell>
                  <TableCell>{amherstIndicativeBaths}</TableCell>
                </TableRow>
              }
              {discrepantData.sqftIsDifferent &&
                <TableRow>
                  <TableCell>Sqft</TableCell>
                  <TableCell>{selectedOpportunity.sqft?.toLocaleString()}</TableCell>
                  <TableCell>{amherstIndicativeSqft?.toLocaleString()}</TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
          <div className={classes.buttonContainer}>
            <Button
              size='small'
              variant='outlined'
              color='primary'
              className={classes.button}
              onClick={() => {
                sendClientLog('Info', `Property UW - User clicked Acknowledge on Discrepant Data popup - txnOpp ${selectedOpportunity.id}`);
                setIsAcknowledged(true);
              }}
            >
              Acknowledge
            </Button>
          </div>
        </>
      </ContentCard>
    </UnderwriteWarningBanner>
  )
}

const styles = theme => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1.5)
  },
  button: {
    margin: theme.spacing(1)
  },
  headerCol: {
    width: '50%',
    textAlign: 'start'
  },
  dataCol: {
    width: '25%',
    textAlign: 'start',
  },
  selectedData: {
    fontWeight: 'bold',
    borderBottom: '2px solid blue',
  },
  table: {
    width: '100%',
    fontSize: '1.2rem',
    padding: '20px 10px',
    //border: '1px solid #ddd',
    borderSpacing: '0px',
  },
  borderBottom: {
    borderBottom: '1px solid black',
    padding: '5px'
  },
});

const mapStateToProps = (state) => ({
  selectedOpportunity: state.propertyUWState.propertyUWClientTxnOpp,
  selectedOpportunityAmherstIndicative: state.propertyUWState.selectedOpportunityAmherstIndicative
})

const mapDispatchToProps = (dispatch) => ({})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PropertyUWDiscrepantData);
